import { render, staticRenderFns } from "./InfoIconSVG.vue?vue&type=template&id=6e2c9dd0&scoped=true&"
var script = {}
import style0 from "./InfoIconSVG.vue?vue&type=style&index=0&id=6e2c9dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c9dd0",
  null
  
)

export default component.exports